export default {
  backgroundRed: {
    backgroundColor: 'red'
  }
}
